export default "__VITE_ASSET__Dqvj2HGD__"